import { DecodedJwtPayload } from '@api/identity/IdentityApi';
import { ApiClient } from '@stereograph/teia-system-design/utils';
import { PluginBuilder, StringController, TeiaViewer } from '@stereograph/teiaviewer';
import { setupPluginsTranslation } from '@translation';
import { jwtDecode } from 'jwt-decode';
import { ShowTeiaAnomalyMenu } from './ToolbarItems';
import { TeiaAnomalyResumeWidget } from './widgets/TeiaAnomalyResumeWidget';

declare global {
  interface ViewerPluginRegistry {
    anomaly: TeiaAnomalyPlugin;
  }
}

const Settings = () => ({
  identityApiUrl: new StringController(''),
});

const PluginBaseClass = PluginBuilder.NewPlugin('TeiaAnomalyPlugin', Settings);

export class TeiaAnomalyPlugin extends PluginBaseClass<TeiaViewer> {
  declare identityAPiClient: ApiClient;
  static override readonly ToolbarItems = {
    ShowTeiaAnomaly: ShowTeiaAnomalyMenu,
  };

  override onRegister(): void {
    this.identityAPiClient = new ApiClient(
      this.settings.identityApiUrl.value,
    );
    setupPluginsTranslation();
    this._setupWidgets();
    this.viewer.settings.twinApi.token.onChange.connect(this._onTokenChange);
  }

  private readonly _onTokenChange = () => {
    this.identityAPiClient.token = this.viewer.settings.twinApi.token.value;
    this._readInstanceTokenFromJwt(this.identityAPiClient.token);
  };

  private _readInstanceTokenFromJwt(jwt: string) {
    const decodedToken = jwtDecode<DecodedJwtPayload>(jwt);
    this.identityAPiClient.instanceToken = decodedToken.instance_token;
  }

  private _setupWidgets() {
    this.viewer.widgetFactory.registerWidget(
      'TeiaAnomalyResume',
      ({ viewportRect, projectId, isAnomalyCreation, ...rest }) => {
        const { width, height } = viewportRect;

        return new TeiaAnomalyResumeWidget(this.viewer, projectId, isAnomalyCreation, {
          x: 5,
          y: 5,
          width: width / 3,
          height: height - 10,
          minWidth: 800,
          minHeight: height - height / 3,
          ...rest,
        });
      },
    );
  }
}
